<script>
    import {modeStore as mode, sizeStore as size} from "./gp-context-fixedcutter.js";
    import OptionButtons from './gp-optionbuttons.svelte';
    import {getGPTransFunc} from "./gp-translations";

    let trans = getGPTransFunc("gp-fixedcutter");

    let sizes = [
        {val : "optionBrush1", icon: "fa-circle", title: trans('Small brush')},
        {val : "optionBrush2", icon: "fa-circle", title: trans('Medium brush')},
        {val : "optionBrush3", icon: "fa-circle", title: trans('Big brush')}
    ];
    let brushes = [
        {val : "optionBrush", icon: "fa-paint-brush", title: trans('Painting')},
        {val : "optionEraser", icon: "fa-eraser", title: trans('Erasing')}
    ];
</script>

<div class="GPFixedCutterOptionButtons GPSearchButtons">
    <OptionButtons bind:value={$size} values={sizes}/>
    <OptionButtons bind:value={$mode} values={brushes}/>
</div>
